import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=7de84379&"
import script from "./ArticleItem.vue?vue&type=script&lang=js&"
export * from "./ArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports